import type {DataRouterFileTreePagePayload, FileOverviewPayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'
import {fileTreeQuery} from '../queries/file-tree-query'
import {latestCommitQuery} from '../queries/latest-commit-query'
import {treeCommitInfoQuery} from '../queries/tree-commit-info-query'

export const codeViewTreeRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewTreeRoute', {
  path: '/:owner/:repo/tree/:branch/*',
  queries: [
    mainQuery<FileOverviewPayload | DataRouterFileTreePagePayload>({
      queryDeps: ({pathname, searchParams}) => ({
        pathname,
        searchParams: {
          search: searchParams.get('search'),
          files: searchParams.get('files'),
        },
      }),
      encodeFetchPath: true,
    }),
    fileTreeQuery,
    latestCommitQuery,
    treeCommitInfoQuery,
  ],
})
